import type { FAQItem } from './types';

export const treasuryFAQs: FAQItem[] = [
  {
    id: 'treasury-overview',
    question: 'What is the Community Treasury and how does it help our reserves?',
    answer: `The **Community Treasury** is designed to centralize reserve management with transparency:

• Treasury dashboard and approval workflow (planned)
• Clear audit trails for board and resident visibility (planned)

No third-party financial institution partnership exists today; any future partner integration would be optional and subject to its own vetting, terms, and disclosures. This describes design intent, not a built feature: treasury data does not persist in the live product yet.`,
    category: 'treasury',
    featured: true,
  },
  {
    id: 'treasury-governance',
    question: 'What approvals would be required before moving reserves?',
    answer: `Treasury actions are designed to be controlled by governance:

• Board proposals and voting thresholds per your bylaws
• Transparent discussion and resident visibility where appropriate
• Documented decisions with audit trails

This is planned functionality; treasury and voting are not yet connected in the live product.`,
    category: 'treasury',
  },
  {
    id: 'treasury-eligibility',
    question: 'Which tiers would include treasury features?',
    answer: `Treasury features are not built yet. The intended tier split is:

• **Starter (Silver)** - core financial transparency; no advanced treasury integrations
• **Professional (Gold)** - enhanced financial tools; any future partner integrations would be optional
• **Enterprise** - custom treasury workflows as contracted

We can scope specifics during implementation planning once treasury functionality is built.`,
    category: 'treasury',
  },
  {
    id: 'treasury-community-treasury-detailed',
    question: 'What is Community Treasury and how would it work?',
    answer: `Community Treasury is designed to be a comprehensive financial management system for community finances. None of the following is live in the product today; it depends on a payment processor and bank data integration, neither of which is built.

**Core Features (planned):**
• **Reserve Fund Management:** Track required reserves with transparency
• **Assessment Collection:** Dues and special assessment processing
• **Vendor Payments:** Approval workflows and digital payments
• **Budget Management:** Budget vs. actual tracking and reporting
• **Financial Reporting:** Monthly statements and annual reports

**Digital Payment Integration (planned):**
• Resident portal for online assessment payments
• Late fee processing and collections
• Integration with existing banking relationships
• Audit trails for financial transactions

This is the design goal, not a built feature: it would reduce manual bookkeeping and improve transparency once implemented.`,
    category: 'treasury',
  },
];
